'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Navbar = require('../../Navbar.js');
require('./NavBrand.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var NavBrand = function () {
    var logoPath = Navbar.useNavbarContext().logoPath;
    return (React__default['default'].createElement("div", { className: "nb-root" },
        React__default['default'].createElement("a", { href: "/", className: "img" },
            React__default['default'].createElement("img", { src: logoPath, alt: "lifepal-user-logo", width: "91px", height: "31px" }))));
};

exports.NavBrand = NavBrand;
//# sourceMappingURL=NavBrand.js.map
